import './App.css';
import 'leaflet/dist/leaflet.css';
import BMWArtCarTracker from './components/BMWArtCarTracker';

function App() {
  return (
    <div className="App">
      <BMWArtCarTracker />
    </div>
  );
}

export default App;